import { TApplicationState } from 'shared/types/redux';
import { MOBILE_PROMOS_LIMIT } from '../../constants/promos';

export function promosMoreButtonEnabledSelector(state: TApplicationState): boolean {
  return state.newbuilding.promoInfos.length > MOBILE_PROMOS_LIMIT;
}
